import { AsyncState, loadingAsyncState } from "widgets-for-react"
import { getCollectionPage } from "../../../../custom_api/api"
import { MoodGroupListWithCover } from "../../../../custom_api/bookarang/types"
import { fetchMoodPrompts } from "../../../../custom_api/collection/api"
import { CollectionPageProps } from '../../../pages/collection_page'

export interface MoodBasedInspirationState {
  collectionPage: AsyncState<CollectionPageProps>
  moodGroups: AsyncState<MoodGroupListWithCover[]>
  routePath: string
  isKioskMode: boolean
}

export const initialMoodBasedState: MoodBasedInspirationState = {
  collectionPage: loadingAsyncState(() => getCollectionPage()),
  moodGroups: loadingAsyncState(fetchMoodPrompts),
  routePath: '',
  isKioskMode: false
}

export type MoodBasedInspirationLayoutProps = MoodBasedInspirationState & {
  pushDataLayer: (action: string, label: string) => void
}